import { useEffect, useState } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from "@/components/ui/carousel";

export default function PhotoGallery({ photos, name }) {
  const [api, setApi] = useState(null);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!api) return;
    const onSelect = () => setCurrent(api.selectedScrollSnap());
    onSelect();
    api.on("select", onSelect);
    return () => { api.off("select", onSelect); };
  }, [api]);

  if (!photos?.length) return null;
  return (
    <div className="relative" data-testid="photo-gallery">
      <Carousel setApi={setApi} opts={{ loop: photos.length > 1 }}>
        <CarouselContent>
          {photos.map((p, i) => (
            <CarouselItem key={p + i} className="sm:basis-1/2 lg:basis-1/3" data-testid={`gallery-slide-${i}`}>
              <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white">
                <img src={p} alt={`${name} photo ${i + 1}`} className="h-56 w-full object-cover" loading="lazy" />
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        {photos.length > 1 && (
          <>
            <CarouselPrevious className="left-3 h-10 w-10 border-0 bg-white/90 shadow-lg" data-testid="gallery-prev" />
            <CarouselNext className="right-3 h-10 w-10 border-0 bg-white/90 shadow-lg" data-testid="gallery-next" />
          </>
        )}
      </Carousel>
      {photos.length > 1 && (
        <div className="mt-3 flex justify-center gap-1.5">
          {photos.map((_, i) => (
            <button key={i} onClick={() => api?.scrollTo(i)} aria-label={`Go to photo ${i + 1}`} data-testid={`gallery-dot-${i}`}
              className={`h-2 rounded-full transition-[width,background-color] ${i === current ? "w-6 bg-brand" : "w-2 bg-slate-300"}`} />
          ))}
        </div>
      )}
    </div>
  );
}
